var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenLinksPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75678 16.5837C4.38164 16.5837 4.06456 16.4541 3.80553 16.1951C3.54651 15.9361 3.41699 15.619 3.41699 15.2439V4.75678C3.41699 4.38164 3.54651 4.06456 3.80553 3.80553C4.06456 3.54651 4.38164 3.41699 4.75678 3.41699H9.6797V4.50033H4.75678C4.69262 4.50033 4.63387 4.52706 4.58053 4.58053C4.52706 4.63387 4.50033 4.69262 4.50033 4.75678V15.2439C4.50033 15.308 4.52706 15.3668 4.58053 15.4201C4.63387 15.4736 4.69262 15.5003 4.75678 15.5003H15.2439C15.308 15.5003 15.3668 15.4736 15.4201 15.4201C15.4736 15.3668 15.5003 15.308 15.5003 15.2439V10.321H16.5837V15.2439C16.5837 15.619 16.4541 15.9361 16.1951 16.1951C15.9361 16.4541 15.619 16.5837 15.2439 16.5837H4.75678ZM8.07887 12.6957L7.30491 11.9218L14.7264 4.50033H12.0003V3.41699H16.5837V8.00033H15.5003V5.27428L8.07887 12.6957Z",
    fill: "#6F00FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLinksPurple);
export default __webpack_public_path__ + "static/media/open-links-purple.1ff0fd6301e47eaef48305cfb25e4ad6.svg";
export { ForwardRef as ReactComponent };